/*
  requires: webapp/lib/ngToast.scss
            webapp/scss_pc/modules/_header.scss
            webapp/scss_pc/modules/_alert.scss
            Font Awesome
*/

declare global {
  interface Window {
    __toast_container_initialized__: boolean | undefined;
  }
}
type ToastType = 'warning' | 'info' | 'success' | 'vq'; // 'vq' は用途不明

function initToastContainer(global: Window) {
  const id = 'ng-toast-container';
  if (global.__toast_container_initialized__) {
    return document.getElementById(id)!;
  }

  global.__toast_container_initialized__ = true;

  const toastContainer = document.createElement('div');
  toastContainer.id = id;
  toastContainer.className =
    'head_notification ng-toast ng-toast--right ng-toast--top';

  const ul = document.createElement('ul');
  ul.className = 'ng-toast__list';

  toastContainer.appendChild(ul);
  document.body.appendChild(toastContainer);

  return toastContainer;
}

const ul = initToastContainer(window).firstChild!;

export function toast({
  text,
  type = 'info',
  time,
}: {
  text: string;
  type?: ToastType;
  time?: number;
}) {
  const li = document.createElement('li');

  const div = document.createElement('div');
  div.className = 'alert alert-' + type;

  const span = document.createElement('span');
  span.innerText = text;

  div.appendChild(span);
  if (time == null) {
    const closeButton = document.createElement('button');
    closeButton.className = 'close';
    closeButton.style.marginLeft = '10px';
    closeButton.addEventListener('click', () => {
      ul.removeChild(li);
    });

    const i = document.createElement('i');
    i.className = 'fa fa-times';
    closeButton.appendChild(i);

    div.appendChild(closeButton);
  }
  li.appendChild(div);
  ul.appendChild(li);

  const close = () => {
    if (li.parentElement) {
      ul.removeChild(li);
    }
  };

  if (time != null) {
    setTimeout(close, time);
  }

  return close;
}

export function toastSuccess(text: string, time = 3000) {
  return toast({ text, type: 'success', time });
}

export function toastError(text: string) {
  return toast({ text, type: 'warning' });
}

/** @deprecated toastSuccessを利用してください*/
export function toastWithCloseTimer({
  text,
  type,
  time = 3000,
}: {
  text: string;
  type?: ToastType;
  time?: number;
}) {
  return toast({ text, type, time });
}

/** @deprecated toastErrorを利用してください*/
export function toastWithCloseButton({
  text,
  type,
}: {
  text: string;
  type?: ToastType;
}) {
  return toast({ text, type });
}

export function closeAllToasts() {
  while (ul.firstChild) {
    ul.removeChild(ul.firstChild);
  }
}
